import { PickerView, Popup } from "antd-mobile"
import styled from "styled-components"

export const MacrosCaloriesPercentWheelPickerPopup = styled(Popup)`
  .adm-popup-body {
    background: linear-gradient(0deg, #032334 0%, #032334 100%),
      rgba(255, 255, 255, 0.4);
    box-shadow: 0px 7.049px 9.612px -4.486px rgba(58, 53, 65, 0.2),
      0px 15.379px 24.351px 1.922px rgba(58, 53, 65, 0.14),
      0px 5.767px 29.477px 5.126px rgba(58, 53, 65, 0.12);
  }

  @media screen and (min-width: 450px) {
    .adm-mask,
    .adm-popup-body {
      max-width: var(--app-max-width);
      left: 50%;
      transform: translateX(-50%) !important;
    }
  }
`

export const PickerViewContainer = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  color: #fff;
  display: flex;
  gap: 8px;
  margin-top: 8px;
`

export const PickerHeader = styled.div`
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
`
export const PickerHeaderTop = styled.div`
  height: 10px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
`

export const PickerHeaderBottom = styled.div`
  height: 36px;
  position: relative;
`

export const DoneButton = styled.div<{ $isDisabled: boolean }>`
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 14px; /* 100% */
  letter-spacing: 0.14px;
  color: ${(props) =>
    props.$isDisabled ? "#69757D" : "var(--Schemes-Primary, #0da3ba)"};
  text-align: center;
  cursor: ${(props) => (props.$isDisabled ? "not-allowed" : "pointer")};
  width: 100%;
  padding: 16px var(--app-horizontal-padding);
  position: absolute;
  right: 0;
  bottom: 0;
  width: min-content;
`

export const StyledPickerView = styled(PickerView)`
  width: 64px;
  height: 305px;
  padding: 0;
  padding-right: 0;
  background: transparent;

  .adm-picker-view-mask {
  }

  .adm-picker-header-button {
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 14px; /* 100% */
    letter-spacing: 0.14px;
    color: var(--Schemes-Primary, #0da3ba);
    padding-top: 14px;
  }

  .adm-picker-view-column-item {
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 160%;
    color: #fff !important;
  }

  .adm-picker-view-column-item-active {
    font-size: 20px;
    font-style: normal;
    font-weight: 800;
    line-height: 120%;
    color: #fff;
  }

  .adm-picker-view-mask-middle {
    height: 39px;
    border: none;
  }

  .adm-picker-view-column-item {
    padding: 0;
  }

  .adm-picker-view-mask-top,
  .adm-picker-view-mask-bottom {
    // background: linear-gradient(0deg, #032334 0%, #032334 100%),
    //   rgba(255, 255, 255, 0.4);
    background: linear-gradient(0deg, #032334 0%, #032334 100%),
      rgba(255, 255, 255, 0);
  }

  .adm-picker-view-mask-top {
    mask: linear-gradient(
      0deg,
      rgba(0, 0, 0, 0.5) 40%,
      rgba(0, 0, 0, 0.6) 50%,
      #000000 100%
    );
  }

  .adm-picker-view-mask-bottom {
    mask: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0.5) 40%,
      rgba(0, 0, 0, 0.6) 50%,
      #000000 100%
    );
  }
`

export const PickerText = styled.div`
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 160%;
  width: 10px;
  position: absolute;
  cursor: pointer;
  pointer-events: none;
  color: var(--Schemes-On-Surface-Variant, #69757d);

  span {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
`

export const PickerSelectedMask = styled.div`
  --picker-border: 1px solid rgba(255, 255, 255, 0.2);

  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  height: 39px;

  border-top: var(--picker-border);
  border-bottom: var(--picker-border);
  width: 100%;
  pointer-events: none;
  z-index: 100000;
`

export const MarcoColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1 1 0;
  gap: 8px;
  color: #fff;
`

export const MarcroInfoBox = styled.div`
  padding: 8px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`
export const MacroName = styled.div`
  font-size: 14px;
  font-weight: 600;
  line-height: 160%;
`

export const MacroGram = styled.div`
  font-size: 16px;
  font-weight: 400;
  line-height: 120%;
  color: var(--Primitive-White_60, rgba(255, 255, 255, 0.6));
`

export const Footer = styled.div`
  padding: 16px 24px;
  margin-bottom: 8px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const TotalPercent = styled.div`
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
`

export const TotalPercentHint = styled.div<{ $isValid: boolean }>`
  font-size: 12px;
  font-weight: 400;
  line-height: 160%;
  color: ${(props) =>
    props.$isValid
      ? "var(--Primitive-White_60, rgba(255, 255, 255, 0.6))"
      : "var(--Schemes-Brand-color-Secondary, #FFC800)"};
`

export const PercentValue = styled.div<{ $isValid: boolean }>`
  font-size: 16px;
  font-weight: 700;
  line-height: 120%;
  color: ${(props) =>
    props.$isValid
      ? "var(--Accent-Data_Dinner, #14c9c9)"
      : "var(--Schemes-Brand-color-Secondary, #FFC800)"};
  text-align: right;
`

export const PercentMaskColumn = styled.div`
  display: flex;
  flex: 1 1 0;
  position: relative;
  height: 100%;
  align-items: center;
`

export const PercentMaskText = styled.div<{ $leftOffset: number }>`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: calc(50% + ${(props) => props.$leftOffset}px);
  color: #fff;
  font-size: 20px;
  font-style: normal;
  font-weight: 800;
  line-height: 120%;
  text-align: center;
`
